export default __webpack_public_path__ + "static/media/kasa_logo.a6101328.svg";